import { cn } from '../cn';

export interface TabBarItemProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  badge?: boolean;
  /** Five tabs on a 390 px phone: tighter pill so no label truncates. */
  compact?: boolean;
}

/**
 * Mobile bottom tab: equal-width column, the label sits in a soft pill when active (fg on the selected surface),
 * fg4 otherwise; a small accent dot marks a badge. No rules or underlines.
 */
export function TabBarItem({ label, active, onClick, badge, compact }: TabBarItemProps) {
  return (
    <button type="button" onClick={onClick} aria-current={active ? 'page' : undefined} className="flex h-tab min-w-0 flex-1 items-center justify-center border-0 bg-transparent p-0">
      <span
        className={cn(
          'inline-flex h-8 max-w-full items-center gap-1.5 rounded-full text-base leading-none transition-colors duration-150',
          compact ? 'px-2' : 'px-3.5',
          active ? 'bg-selected font-semibold text-fg' : 'font-medium text-fg4',
        )}
      >
        <span className="truncate">{label}</span>
        {badge && <span aria-label="has open items" className="h-1.5 w-1.5 flex-none rounded-full bg-accent" />}
      </span>
    </button>
  );
}
